import React from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { useCompany } from '../../../context/CompanyContext';
import Sidebar from './Sidebar';
import Header from './Header';
import './AdminLayout.css';

const PAGES_WITHOUT_COMPANY = ['/admin/companies', '/admin/users'];

const AdminLayout = () => {
  const { companyId, loading, isSuperAdmin } = useCompany();
  const { pathname } = useLocation();
  const skipCompanyCheck = PAGES_WITHOUT_COMPANY.some((p) => pathname.startsWith(p));

  return (
    <div className="admin-layout">
      <Sidebar />
      <div className="admin-main">
        <Header />
        <main className="admin-content">
          {loading ? (
            <div className="admin-loading">Cargando...</div>
          ) : skipCompanyCheck ? (
            <Outlet />
          ) : !companyId && isSuperAdmin ? (
            <div className="admin-no-company">
              <p>No hay empresas registradas o selecciona una empresa en el menú superior.</p>
            </div>
          ) : !companyId ? (
            <div className="admin-no-company">
              <p>No tienes una empresa asignada. Contacta al administrador.</p>
            </div>
          ) : (
            <Outlet />
          )}
        </main>
      </div>
    </div>
  );
};

export default AdminLayout;

